<template>
    <UCard>
        <template #header>
            <h1 class="text-lg font-medium text-slate-950">{{ title }}</h1>
        </template>

        <slot />
    </UCard>

</template>

<script setup lang="ts">
defineProps<{
    title: string
}>()
</script>